import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    inquiryType: '',
    message: '',
    agreeToTerms: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const inquiryTypes = [
    { value: 'tenant', label: 'Oportunidade de Locação' },
    { value: 'partnership', label: 'Parceria Comercial' },
    { value: 'visit', label: 'Informações para Visita' },
    { value: 'event', label: 'Organização de Eventos' },
    { value: 'general', label: 'Informações Gerais' },
    { value: 'maintenance', label: 'Manutenção/Suporte' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSelectChange = (value) => {
    setFormData(prev => ({
      ...prev,
      inquiryType: value
    }));
  };

  const handleCheckboxChange = (e) => {
    setFormData(prev => ({
      ...prev,
      agreeToTerms: e?.target?.checked
    }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        inquiryType: '',
        message: '',
        agreeToTerms: false
      });
      
      setTimeout(() => {
        setSubmitStatus(null);
      }, 5000);
    }, 2000);
  };

  return (
    <div className="bg-card rounded-xl shadow-warm p-8 lg:p-10 border border-border/50">
      <div className="flex items-center space-x-4 mb-8">
        <div className="flex items-center justify-center w-12 h-12 bg-primary rounded-xl">
          <Icon name="MessageSquare" size={24} className="text-primary-foreground" />
        </div>
        <div>
          <h3 className="text-2xl font-heading font-semibold text-foreground">
            Entre em Contato
          </h3>
          <p className="text-base text-muted-foreground">
            Envie sua mensagem e responderemos em breve
          </p>
        </div>
      </div>
      {submitStatus === 'success' && (
        <div className="mb-8 p-6 bg-success/10 border border-success/20 rounded-xl">
          <div className="flex items-center space-x-3">
            <Icon name="CheckCircle" size={24} className="text-success" />
            <p className="text-success font-semibold text-base">
              Mensagem enviada com sucesso! Entraremos em contato em breve.
            </p>
          </div>
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Nome Completo"
            type="text"
            name="name"
            placeholder="Seu nome completo"
            value={formData?.name}
            onChange={handleInputChange}
            required
          />
          
          <Input
            label="E-mail"
            type="email"
            name="email"
            placeholder="seu@email.com"
            value={formData?.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Telefone"
            type="tel"
            name="phone"
            placeholder="(11) 99999-9999"
            value={formData?.phone}
            onChange={handleInputChange}
          />
          
          <Input
            label="Empresa (Opcional)"
            type="text"
            name="company"
            placeholder="Nome da empresa"
            value={formData?.company}
            onChange={handleInputChange}
          />
        </div>

        <Select
          label="Tipo de Consulta"
          placeholder="Selecione o tipo de consulta"
          options={inquiryTypes}
          value={formData?.inquiryType}
          onChange={handleSelectChange}
          required
        />

        <div>
          <label className="block text-base font-semibold text-foreground mb-3">
            Mensagem
          </label>
          <textarea
            name="message"
            rows={6}
            placeholder="Descreva sua consulta ou necessidade..."
            value={formData?.message}
            onChange={handleInputChange}
            required
            className="w-full px-4 py-3 border border-border rounded-xl bg-input text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent resize-none text-base leading-relaxed"
          />
        </div>

        <Checkbox
          label="Concordo em receber comunicações da Estação Marina"
          description="Você pode cancelar a inscrição a qualquer momento"
          checked={formData?.agreeToTerms}
          onChange={handleCheckboxChange}
          required
        />

        <div className="pt-4">
          <Button
            type="submit"
            variant="default"
            size="lg"
            fullWidth
            loading={isSubmitting}
            disabled={!formData?.agreeToTerms}
            iconName="Send"
            iconPosition="right"
            className="h-14 text-lg font-semibold"
          >
            {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;